import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { CONTACT_EMAIL, LAST_UPDATED } from "@/lib/legal";

export function LegalLayout({ title, children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505]">
      <div className="max-w-md mx-auto min-h-screen bg-[#0A0A0A] px-5 pt-8 pb-16">
        <button
          data-testid="legal-back-button"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))}
          className="mb-4 -ml-3 h-11 pl-2 pr-4 rounded-full flex items-center gap-1 text-[15px] font-medium text-[#A1A1AA] hover:text-white active:bg-[#161618] transition-colors"
        >
          <ChevronLeft size={22} /> Back
        </button>
        <h1 className="font-display text-3xl font-bold uppercase tracking-tight" data-testid="legal-title">{title}</h1>
        <p className="text-xs text-[#71717A] mt-2 mb-8">Last updated: {LAST_UPDATED}</p>
        <div className="space-y-7 text-[15px] leading-relaxed text-[#D4D4D8] [&_h2]:font-display [&_h2]:text-lg [&_h2]:uppercase [&_h2]:tracking-tight [&_h2]:text-white [&_h2]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_p+p]:mt-2 [&_a]:text-white [&_a]:underline [&_a]:decoration-[#E50914] [&_a]:underline-offset-4">
          {children}
        </div>
        <p className="text-sm text-[#71717A] mt-10">Questions? Email <a className="text-white underline decoration-[#E50914] underline-offset-4" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
      </div>
    </div>
  );
}
